import React from 'react';
import { modules } from '../data/content';
export function Product() {
  return <section className="bg-concrete-950 py-16 sm:py-24" aria-labelledby="producto" data-id="element-154" data-mp="1y57hla1m7mdu">
      <div className="mx-auto max-w-7xl px-5 sm:px-8" data-id="element-155" data-mp="1y33c4no2ifbg">
        <div className="grid gap-10 lg:grid-cols-[1.05fr_1fr] lg:items-center lg:gap-16" data-id="element-156" data-mp="1k4wpy4she3rm">
          <div data-id="element-157" data-mp="1p3q5s3v8q6uy">
            <p className="text-sm font-bold uppercase tracking-[0.2em] text-safety" data-id="element-158" data-mp="1p37zsfis0e9u">
              Te presento
            </p>
            <h2 id="producto" className="mt-3 font-display text-4xl uppercase leading-[0.95] text-concrete-50 sm:text-6xl" data-id="element-159" data-mp="1ae224vzl6w42">
              Megapack Constructor Elite 360
            </h2>
            <p className="mt-6 text-lg leading-relaxed text-concrete-200 sm:text-xl" data-id="element-160" data-mp="15gaam32utc0e">
              Este no es un curso aburrido de la escuela. Es la{' '}
              <strong className="font-bold text-concrete-50" data-id="element-161" data-mp="rhsog9slk7kl">
                Biblia del Contratista Moderno
              </strong>
              : 6 tomos en PDF que te enseñan paso a paso cómo armar tu propia
              constructora, presupuestar sin fallar y cerrar tratos que sí dejen
              billete.
            </p>
          </div>
          <img src="https://cdn.magicpatterns.com/uploads/vpTFZA5be2uLotBeoSdJmC/constructor_1.png" alt="Los 6 tomos del Megapack Constructor Elite 360 con sus módulos extras y 5 bonos" className="w-full border-2 border-concrete-700 bg-concrete-900 p-2 sm:p-3" data-id="element-162" data-mp="1ref25crb0pkr" />
        </div>

        <h3 className="mt-16 font-display text-2xl uppercase text-concrete-50 sm:text-3xl" data-id="element-163" data-mp="uoo0mtkli25g">
          Lo que vas a dominar
        </h3>

        <ol className="mt-8 grid gap-px overflow-hidden border border-concrete-700 bg-concrete-700 sm:grid-cols-2 lg:grid-cols-3" data-id="element-164" data-mp="18h46010yyc9j">
          {modules.map(m => <li key={m.tomo} className="flex flex-col bg-concrete-900 p-5 sm:p-7" data-id="element-165" data-mp="fxfckowccouf">
              <span className="font-display text-sm uppercase tracking-[0.2em] text-safety" data-id="element-166" data-mp="b0f3e54735z3">
                {m.tomo}
              </span>
              <h4 className="mt-3 font-display text-2xl uppercase leading-tight text-concrete-50" data-id="element-167" data-mp="2b1mw36jitprv">
                {m.title}
              </h4>
              <p className="mt-3 text-base leading-relaxed text-concrete-400" data-id="element-168" data-mp="2kr6ds8vhzdl5">
                {m.text}
              </p>
            </li>)}
        </ol>
      </div>
    </section>;
}